import { defineStore } from 'pinia'






interface ContentRootState {
    initialised: boolean
		working: boolean

		content: {
			blog: GlobalContentType<ContentBlog>
			products: GlobalContentType<ContentProduct>
		}


		industries: Array<{
			name: string, 
			description: string, 
			image: string, 
			slug: string
		}>
		applications: Array<{
			name: string, 
			description: string, 
			image: string, 
			slug: string
		}>
		distribution: Array<{
			id: string, 
			title: string,
			description: string[],
			colorCode: string
		}>
		services: Array<{
			name: string, 
			description: string, 
			image: string, 
			slug: string
		}>
		solutions: Array<{
			title: string,
			image: string,
			description: string,
			slug: string,
			content: {
				intro: string,
				points: string[]
			}
		}>

		products: Array<{
			titles: Record<string, string>,
			description: {
				short: string,
				long: string
			},
			category: string,
			image: string,
			slug: string,
		}>

		productCategories: Array<{
			labels: {
				short: string,
				full: string,
			},
			color: string,
			description: string,
			image: string,
			slug: string,
			icon: string,
		}>

		sds: GlobalContentType<ContentSDS>
}

export const useContentStore = defineStore('content', {

	state: (): ContentRootState => ({
			initialised: true,
			working: false,


			content: {
				blog: {
					init: false,
					working: false,

					records: [],
					total: 0,
					limit: 10,
					sort: "date",
					order: "desc",
					page: 1
				},
				product: {
					init: false,
					working: false,

					records: [],
					total: 0,
					limit: 50,
					sort: "date",
					order: "desc",
					page: 1
				},
				sds: {
					init: false,
					working: false,
					records: [] as ContentSDS[],
					total: 0,
					limit: 100,
					sort: "date",
					order: "asc",
					page: 1,
				}
			},


			industries: [
				{
					name: 'Pharmaceuticals and Healthcare',
					description: 'Essential for drug formulation, sterilisation products, and medical-grade disinfectants, meeting stringent healthcare standards.',
					image: '/pills.jpg',
					slug: 'pharmaceuticals-and-healthcare',
				},
				{
					name: 'Food and Beverage',
					description: 'Crucial in Flavour extraction, food preservation, and processing, adhering to safety and quality regulations.',
					image: '/food.jpg',
					slug: 'food-and-beverage',
				},
				{
					name: 'Cosmetics and Personal Care',
					description: 'Integral in producing fragrances, creams, and beauty products, focusing on safety, purity, and sustainability.',
					image: '/cosmetics.jpg',
					slug: 'cosmetics-and-personal-care',
				},
				{
					name: 'Energy and Biofuels',
					description: 'Supporting sustainable energy solutions through the production of biofuels, emphasising eco-friendly and efficient processes.',
					image: '/energy.jpg',
					slug: 'energy-and-biofuels',
				},
				{
					name: 'Industrial Manufacturing',
					description: 'Serving a range of sectors like automotive and electronics with solvents for cleaning, degreasing, and production.',
					image: '/industrial.jpg',
					slug: 'industrial-manufacturing',
				},
				{
					name: 'Paints and Coatings',
					description: 'Supplying solvents for paints and coatings, balancing efficiency, safety, and environmental impact.',
					image: '/paints.jpg',
					slug: 'paints-and-coatings',
				},
				{
					name: 'Environmental Services',
					description: 'Involved in waste management and recycling, contributing to environmental remediation and sustainable practices.',
					image: '/environmental.jpg',
					slug: 'environmental-services',
				},
				{
					name: 'Agriculture',
					description: 'Providing ethanol-based chemicals for pesticides and agricultural products, focusing on effectiveness and safety.',
					image: '/agriculture.jpg',
					slug: 'agriculture',
				},
				{
					name: 'Textiles and Dyes',
					description: 'Facilitating dye production and textile processing with specialised solvents, ensuring quality and consistency.',
					image: '/textiles.jpg',
					slug: 'textiles-and-dyes',
				},
				{
					name: 'Laboratory and Research',
					description: 'Offering high-purity solvents for a variety of research and analytical applications in scientific settings.',
					image: '/labres.jpg',
					slug: 'laboratory-and-research',
				},
				{
					name: 'Construction and Building Materials',
					description: 'Supplying solvents used in the production of adhesives, sealants, and other building materials, ensuring durability and quality.',
					image: '/construction.jpg',
					slug: 'construction-and-building-materials',
				},
				{
					name: 'Printing and Packaging',
					description: 'Essential in ink formulation and packaging processes, focusing on quality, efficiency, and adaptability to various materials.',
					image: '/printing.jpg',
					slug: 'printing-and-packaging',
				},
			],


			services: [
					{
							name: 'Tailored Ethanol Blending',
							description: 'Harnessing the multifaceted power of ethanol, we offer a range of environmentally-conscious blends that prioritise both efficiency and sustainability.',
							// image: '/lab.jpg',
							// image: '/images/ethanol-blending.jpg',
							image: '/images/industries/energy-and-biofuel.jpg',
							slug: 'ethanol-blending',
					},
					{
							name: 'Essential Chemicals',
							description: 'Playing an integral role in our everyday lives, these chemicals are not just foundational; they drive innovation and foster progress in myriad applications.',
							//image: '/images/essential-chemicals.jpg',
							// image: '/essential-chemicals.jpg',
							// image: '/chem-6.jpg',
							// image: '/chem-7.jpg',
							image: '/custom-solutions.jpg',
							// image: '/chem-9.jpg',
							slug: 'essential-chemicals',
					},
					{
							name: 'Manufactured Products',
							description: 'Every product we craft is meticulously designed with an end-goal in mind, ensuring optimal results tailored to specific use cases.',
							// image: '/perfume.jpg',
							image: '/isolve-10.jpg',
							slug: 'manufactured-products',
					},
					{
							name: 'Manufacturing as a Service',
							description: 'Our tailored manufacturing solutions cater to a multitude of sectors. We are more than a service provider; we are a dedicated partner in your production journey.',
							// image: '/assembly.jpg',
							image: '/water-industry.jpg',
							slug: 'manufacturing-as-a-service',
					},
					{
							name: 'Hazardous Waste Solutions',
							description: 'Beyond mere management, we see hazardous waste as an opportunity. Our approaches not only handle but also transform waste into environmental milestones.',
							// image: '/hazardous.jpg',
							image: '/chem-1.jpg',
							slug: 'hazardous-waste-solutions',
					},
					// {
					// 	name: 'Custom Solutions',
					// 	description: 'Every industry comes with its unique challenges and demands. We specialise in crafting chemical solutions that are tailored specifically to meet those nuanced needs.',
					// 	image: '/custom-solutions.jpg',
					// 	slug: 'custom-solutions',
					// },
					// {
					// 		name: 'Fuel Towards Energy',
					// 		description: 'Our heavy fuel oil and ethanol-blended fuels offer a robust solution for energy needs, providing a balanced approach between performance and sustainability.',
					// 		image: '/images/8.jpeg',
					// 		slug: 'fuel-towards-energy',
					// }
			],
	
			applications: [
				{
					"name": "Antiseptic and Topical Uses",
					"description": "Widely used in antiseptics and topical solutions, essential for medical and personal care applications due to its sanitising properties.",
					"image": "/images/applications/antiseptic.jpg",
					"slug": "antiseptic-and-topical-uses"
				},
				{
					"name": "Biofuel Production",
					"description": "A key component in the manufacturing of biofuels, supporting sustainable energy production through efficient processing.",
					"image": "/images/applications/biofuels.jpg",
					"slug": "biofuel-production"
				},
				{
					"name": "Flavour and Fragrance Extraction",
					"description": "Ideal for extracting delicate flavours and fragrances, playing a vital role in the food, beverage, and cosmetics industries.",
					"image": "/images/applications/flavour.jpg",
					"slug": "Flavour-and-fragrance-extraction"
				},
				{
					"name": "Food Preservation",
					"description": "Essential for maintaining food safety and extending shelf life, ensuring high-quality products in the food processing industry.",
					"image": "/images/applications/food-preservation.jpg",
					"slug": "food-preservation"
				},
				{
					"name": "Ink and Dye Production",
					"description": "A critical component in the production of inks and dyes, supporting the printing and textile industries with vibrant and lasting colours.",
					"image": "/images/applications/ink.jpg",
					"slug": "ink-and-dye-production"
				},
				{
					"name": "Solvents in Laboratories",
					"description": "A versatile solvent widely used in laboratory applications, enabling reliable outcomes in scientific research and development.",
					"image": "/images/applications/solventslab.jpg",
					"slug": "solvents-in-laboratories"
				},
				{
					"name": "Sterilisation and Disinfection",
					"description": "Highly effective in sterilisation and disinfection processes, critical in healthcare and sanitation to ensure safe and hygienic environments.",
					"image": "/images/applications/disinfection.jpg",
					"slug": "sterilisation-and-disinfection"
				},
				{
					"name": "Thermal Insulation",
					"description": "Plays a pivotal role in developing thermal insulating materials, improving energy efficiency in buildings and industrial applications.",
					"image": "/images/applications/thermal.jpg",
					"slug": "thermal-insulation"
				},
				// {
				// 	"name": "Time Travel",
				// 	"description": "A fascinating concept that continues to inspire scientific research and theoretical advancements in the realm of physics.",
				// 	"image": "/images/9.jpeg",
				// 	"slug": "time-travel"
				// }
			],

			
			distribution: [
					{
						"id": "01",
						"title": "Core Materials",
						"description": [
							"We begin by sourcing high-quality packing materials that ensure product safety and integrity.",
							"Our network of trusted suppliers provides us with premium materials, including boxes, bottles, dispensers, and protective packaging."
						],
						"colorCode": "#FF0000"
					},
					{
						"id": "02",
						"title": "Product Packing",
						"description": [
							"Our expert team carefully packs your products, utilizing advanced techniques to maximize protection and efficiency.",
							"Whether it's delicate items or bulk goods, our packing process is tailored to each product's specific needs."
						],
						"colorCode": "#FF7F00"
					},
					{
						"id": "03",
						"title": "Labeling and Compliance",
						"description": [
							"Next, we ensure that all products are accurately labeled with essential information, including product details, barcodes, and regulatory compliance labels.",
							"Our meticulous approach guarantees clarity and adherence to legal standards."
						],
						"colorCode": "#FFFF00"
					},
					{
						"id": "04",
						"title": "Quality Control",
						"description": [
							"Quality control checks are conducted throughout the packing process.",
							"We inspect each item to ensure it meets our stringent standards, ensuring that only the best-quality products are ready for distribution."
						],
						"colorCode": "#7FFF00"
					},
					{
						"id": "05",
						"title": "Inventory Management",
						"description": [
							"Our inventory management system efficiently tracks and manages products, ensuring quick retrieval and accurate dispatch.",
							"This system is vital for maintaining optimal stock levels and ensuring timely deliveries."
						],
						"colorCode": "#00FF00"
					},
					{
						"id": "06",
						"title": "Order Fulfillment",
						"description": [
							"We handle order fulfillment with precision, ensuring that each order is accurately assembled and ready for shipping.",
							"Our streamlined process ensures that orders are processed quickly and efficiently."
						],
						"colorCode": "#00FF7F"
					},
					{
						"id": "07",
						"title": "Shipping and Distribution",
						"description": [
							"Our logistics network facilitates both national and international shipping.",
							"We coordinate with reliable carriers to ensure your products are delivered on time and in perfect condition, whether it's local delivery or global distribution."
						],
						"colorCode": "#00FFFF"
					},
					{
						"id": "08",
						"title": "After-Sales Support",
						"description": [
							"Post-distribution, we provide comprehensive after-sales support, including customer inquiries and returns management.",
							"Our team is dedicated to ensuring complete customer satisfaction even after the product reaches its destination."
						],
						"colorCode": "#007FFF"
					}
				],

		products: [],
		
		productCategories: [
			{
				labels: {
					short: 'Blends',
					full: 'Ethanol & Ethanol Blends',
				},
				color: '#2727e0',
				description: 'Blends',
				image: '/images/1.jpeg',
				slug: 'ethanol',
				icon: '',
			},
			{
				labels: {
					short: 'Chemicals',
					full: 'Essential Chemicals',
				},
				color: 'rgb(89 6 149)',
				description: 'Essential Chemicals',
				image: '/images/1.jpeg',
				slug: 'essential-chemicals',
				icon: '',
			},
			{
				labels: {
					short: 'Manufactured',
					full: 'Manufactured Products',
				},
				color: 'rgb(33 150 196)',
				description: 'Manufactured Products',
				image: '/images/1.jpeg',
				slug: 'manufactured-products',
				icon: '',
			},
			{
				labels: {
					short: 'Synthetic',
					full: 'Synthetic',
				},
				color: 'rgb(179 73 107)',
				description: 'Synthetic',
				image: '/images/1.jpeg',
				slug: 'synthetic',
				icon: '',
			},
			{
				labels: {
					short: 'Bases',
					full: 'Bases',
				},
				color: 'rgb(22 137 133)',
				description: 'Bases',
				image: '/images/1.jpeg',
				slug: 'bases',
				icon: '',
			},
		]

	}),

	actions: {
			updateInitialised(initValue: boolean) {
					this.initialised = initValue
			},
	},

	getters: {
			getInitialised: state => state.initialised,
	},
})